import React, { createRef } from 'react'

//UI
import { Grid, Tab, Tabs, Button } from '@material-ui/core'
//Components
import BiotrackLocations from './BiotrackLocations'
import EditActionComponent from '../common/EditActionComponent'
import ModalDialog from '../common/ModalDialog'
//Utils
import { createCopy } from '../../utils/common'
import MetrcMergedFacilities from './MetrcMergedFacilites'
import MetrcEmployees from '../Metrc/MetrcEmployees'
import AddMetrcEmployeeModal from '../Metrc/AddMetrcEmployeeModal'
import { getShopList } from '../../actions/shop'
import { openErrorMessage } from '../../actions/message'
import _ from 'lodash'
import {
  deletedMerchantEmployeeKey,
  updateMerchant,
  updateMerchantEmployeeKey,
} from '../../api/complianceService'
import {
  serializeBiotrackConfigRequest,
  serializeMetrcConfigRequest,
  serializeMetrcEmployeeConfigRequest,
} from '../../utils/complianceServiceDataBuilders'
import UtahIcsFacilities from './UtahIcsFacilities'
import NmCcdAccount from './NmCcdAccount'

export default class Compliance extends React.PureComponent {
  addMetrcEmployeeModal = createRef()

  onChangeActiveTab = (_, val) => {
    this.props.onChangeActiveTab(val)
  }

  onChangeLocation = (id, key, isCheckBox) => {
    return (e) => {
      const { data } = this.props
      const value = isCheckBox ? e.target.checked : e.target.value
      const locations = createCopy(data.locations)

      const location = locations.find((location) => location.id === id)
      const pos = locations.findIndex((l) => l.id === location.id)

      locations[pos] = {
        ...location,
        [key]: value,
      }

      this.props.onChange('locations', locations)
    }
  }

  onChangeFacility = (id, key, isCheckBox, packageLocationFlag = false) => {
    return (e) => {
      const { data, facilitiesOptions = [] } = this.props
      const value = isCheckBox ? e.target.checked : e.target.value
      const facilities = createCopy(data.facilities)

      const facility = facilities.find((facility) => facility.id === id)
      const pos = facilities.findIndex((f) => f.id === facility.id)
      facilities[pos] = {
        ...facility,
        [key]: value,
      }

      let {
        enablePackageLocationTracking = false,
        facLicense = '',
        stateCode = '',
      } = facilities[pos]
      if (enablePackageLocationTracking) {
        let metrcFacility = _.find(facilitiesOptions[stateCode] || [], {
          License: { Number: facLicense },
        })
        if (key === 'facLicense') {
          facilities[pos]['enablePackageLocationTracking'] =
            metrcFacility.FacilityType.canUpdateLocationsOnPackages
          facilities[pos]['enablePackageLocationTracking'] &&
            this.props.dispatch(
              openErrorMessage(
                'WARNING: Metrc Package Location Tracking is Enabled.  If you change your METRC facility, you will delete your Metrc default location and your inventory-to-compliance room mappings.',
              ),
            )
        }
        if (key === 'enablePackageLocationTracking' && value) {
          this.props.dispatch(
            openErrorMessage(
              'WARNING: Package tracking feature enabled. You must set a new default metrc location. Check below this table to confirm if you have a default metrc location!',
            ),
          )
        }
      }
      this.props.onChange('facilities', facilities)
    }
  }

  onAddNewLocation = (data) => {
    const locations = createCopy(this.props.data.locations)
    locations.push(data)
    this.props.onChange('locations', locations)
  }

  onAddNewFacility = (data) => {
    const facilities = createCopy(this.props.data.facilities)
    facilities.push(data)
    this.props.onChange('facilities', facilities)
  }

  onChangeUtahFacility = (id, key, isCheckBox = false) => {
    return (e) => {
      const { data } = this.props
      const account = createCopy(data.utahIcsAccount || {})
      const facilities = createCopy(account.facilities || [])
      const value = isCheckBox ? e.target.checked : e.target.value
      const pos = facilities.findIndex((facility) => (facility.id || facility._id) === id)

      if (pos >= 0) {
        const facility = facilities[pos]
        facilities[pos] = { ...facility, [key]: value }
        this.props.onChange('utahIcsAccount', { ...account, facilities })
      }
    }
  }

  onAddNewUtahFacility = (facilityPayload = {}) => {
    const { data } = this.props
    const account = createCopy(data.utahIcsAccount || {})
    const facilities = createCopy(account.facilities || [])
    const facilityId = facilityPayload.id || facilityPayload._id || `utah-ics-${Date.now()}`
    const newFacility = {
      id: facilityId,
      shopId: facilityPayload.shopId,
      stateCode: facilityPayload.stateCode || account.stateCode || 'UT',
      environment: facilityPayload.environment || account.environment || 'Development',
      facilityCode: facilityPayload.facilityCode || '',
      sourceSystem:
        facilityPayload.sourceSystem || facilityPayload.facilityCode || account.sourceSystem || '',
      clientId: facilityPayload.clientId || account.clientId || '',
      clientSecret: facilityPayload.clientSecret || '',
      enabled: facilityPayload.enabled || false,
      enableSync: facilityPayload.enableSync || false,
      companyId: account.companyId,
    }
    this.props.onChange('utahIcsAccount', { ...account, facilities: [...facilities, newFacility] })
  }

  onRemoveUtahFacility = (facilityId) => {
    const { data } = this.props
    const account = createCopy(data.utahIcsAccount || {})
    const facilities = createCopy(account.facilities || [])
    const target = facilities.find((facility) => (facility.id || facility._id) === facilityId)
    const removeLocal = () => {
      const updatedFacilities = facilities.filter(
        (facility) => (facility.id || facility._id) !== facilityId,
      )
      this.props.onChange('utahIcsAccount', { ...account, facilities: updatedFacilities })
    }

    // If no persisted id, just remove locally.
    if (!target || !(target.id || target._id)) {
      removeLocal()
      return
    }

    if (this.props.onDeleteUtahAccount) {
      this.props
        .onDeleteUtahAccount(target.id || target._id)
        .then(() => removeLocal())
        .catch(() => {})
    } else {
      removeLocal()
    }
  }

  onSave = () => {
    this.props.onSave((_) => {
      this.props.disableEdit()
      const locations = this.props.data.locations ?? []
      this.updateBiotrackConfigsInComplianceService(locations)
    })
  }

  updateBiotrackConfigsInComplianceService = (locations) => {
    locations
      .filter((location) => location.environment)
      .forEach((location) => {
        const { companyId, shopId } = location
        const request = serializeBiotrackConfigRequest(location)
        updateMerchant(companyId, shopId, request)
      })
  }

  onFacilititesSave = () => {
    this.props.onFacilititesSave(this.props.data, (_) => {
      this.props.disableEdit()
      this.props.dispatch(getShopList())
      const facilities = this.props.data.facilities ?? []
      this.updateMetrcConfigsInComplianceService(facilities)
    })
  }

  updateMetrcConfigsInComplianceService = (facilities) => {
    facilities
      .filter((facility) => facility.environment)
      .forEach((facility) => {
        const { companyId, shopId } = facility
        const request = serializeMetrcConfigRequest(facility)
        updateMerchant(companyId, shopId, request)
      })
  }

  onUtahIcsSave = () => {
    this.props.onUtahIcsSave(this.props.data, (_) => {
      this.props.disableEdit()
    })
  }

  checkApiKey = (id) => () => {
    const { data } = this.props
    const facilities = createCopy(data.facilities)

    const facility = facilities.find((facility) => facility.id === id)
    this.props.searchFacilities(facility.environment, facility.stateCode, facility.userApiKey)
    this.props.enableEdit()
  }

  onCancel = () => {
    this.props.onCancel()
  }

  openMetrcEmployeeModal = () => {
    this.addMetrcEmployeeModal.current.handleClickOpen()
  }

  openDeleteModal = (employeeKey) => {
    this.props.setEmployeeKeyForDelete(employeeKey)
    this.deleteModal.handleClickOpen()
  }

  onSaveEmployeeKey = (request) => {
    if (this.props.validateEmployeeKey(request)) {
      this.props.saveEmployeeKey(request).then((res) => {
        this.props.onSearchEmployeeKey()
        this.updateEmployeeMetrcKeyForMerchants(res)
        this.addMetrcEmployeeModal.current.handleClose()
      })
    }
  }

  updateEmployeeMetrcKeyForMerchants = (data) => {
    const { userApiKey, companyId, employeeId, enabled } = data
    const request = serializeMetrcEmployeeConfigRequest(userApiKey, enabled)
    updateMerchantEmployeeKey(companyId, employeeId, request)
  }

  onDeleteEmployeeKey = () => {
    const { selectedEmployeeKey = {} } = this.props
    if (selectedEmployeeKey && selectedEmployeeKey.id) {
      this.props.deleteEmployeeKey(selectedEmployeeKey.id).then((res) => {
        const { companyId, employeeId } = selectedEmployeeKey
        deletedMerchantEmployeeKey(companyId, employeeId)
        this.props.onSearchEmployeeKey()
        this.deleteModal.handleClose()
      })
    }
  }

  onSaveUtahFacility = (facilityId) => {
    const account = createCopy(this.props.data.utahIcsAccount || {})
    const facilities = account.facilities || []
    const facility = facilities.find((f) => (f.id || f._id) === facilityId)
    if (!facility) return
    const payload = { ...account, facilities: [facility] }
    return this.props.onUtahFacilitySave(payload)
  }

  render() {
    const {
      data,
      editMode,
      shops = [],
      TABS,
      activeTab,
      facilitiesOptions = {},
      retrieveFacilities,
      metrcLocationTypes,
      employees = [],
      metrcEmployeeKeys = [],
      selectedEmployeeKey = {},
      shop,
      showUtahTab = true,
      utahShops = [],
      showNmCcdTab = false,
      nmCcdAccount = {},
      nmCcdAccounts = [],
    } = this.props

    const utahTabVisible = showUtahTab && utahShops && utahShops.length > 0

    return (
      <React.Fragment>
        <Grid container>
          <Grid item xs={9} sm={9} md={9} lg={9} className="cus_tabs">
            {true ? (
              <Tabs
                value={activeTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={this.onChangeActiveTab}
                scrollable
                scrollButtons="auto"
              >
                <Tab label="BioTrack Locations" value={TABS.BIOTRACK_LOCATIONS} />
                <Tab label="Metrc Facilities" value={TABS.METRC_FACILITIES} />
                <Tab label="Metrc Employees" value={TABS.METRC_EMPLOYEE_KEYS} />
                {utahTabVisible ? <Tab label="Utah ICS" value={TABS.UTAH_ICS} /> : null}
                {showNmCcdTab ? <Tab label="New Mexico CCD" value={TABS.NM_CCD} /> : null}
              </Tabs>
            ) : null}
          </Grid>
          <Grid item xs={3} sm={3} md={3} lg={3}>
            {activeTab === TABS.BIOTRACK_LOCATIONS ? (
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
            ) : null}
            {activeTab === TABS.METRC_FACILITIES ? (
              <EditActionComponent
                onSave={this.onFacilititesSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
            ) : null}
            {activeTab === TABS.METRC_EMPLOYEE_KEYS ? (
              <div className="pull-right margin-bottom-small margin-top">
                <Button onClick={this.openMetrcEmployeeModal} className="primary-button margin">
                  Add Employee Key
                </Button>
              </div>
            ) : null}
          </Grid>
        </Grid>
        {activeTab === TABS.BIOTRACK_LOCATIONS ? (
          <BiotrackLocations
            data={data}
            shops={shops}
            onChangeLocation={this.onChangeLocation}
            editMode={editMode}
            onAddNewLocation={this.onAddNewLocation}
            dispatch={this.props.dispatch}
          />
        ) : null}
        {activeTab === TABS.METRC_FACILITIES ? (
          <MetrcMergedFacilities
            onChangeFacility={this.onChangeFacility}
            onAddNewFacility={this.onAddNewFacility}
            retrieveFacilities={retrieveFacilities}
            facilitiesOptions={facilitiesOptions}
            checkApiKey={this.checkApiKey}
            data={data}
            editMode={editMode}
            shops={shops}
            shop={shop}
            metrcLocationTypes={metrcLocationTypes}
            dispatch={this.props.dispatch}
          />
        ) : null}
        {activeTab === TABS.UTAH_ICS && utahTabVisible ? (
          <UtahIcsFacilities
            data={data}
            shops={utahShops}
            editMode={editMode}
            onChangeFacility={this.onChangeUtahFacility}
            onAddFacility={this.onAddNewUtahFacility}
            onRemoveFacility={this.onRemoveUtahFacility}
            onSaveFacility={this.onSaveUtahFacility}
          />
        ) : null}
        {activeTab === TABS.NM_CCD && showNmCcdTab ? (
          <NmCcdAccount
            account={nmCcdAccount}
            accounts={nmCcdAccounts}
            shops={shops}
            shop={shop}
            onSave={this.props.onNmCcdSave}
            onDelete={this.props.onDeleteNmCcdAccount}
            onTest={this.props.onTestNmCcdConnection}
            notifySuccess={this.props.notifyNmCcdSuccess}
            notifyError={this.props.notifyNmCcdError}
          />
        ) : null}
        {activeTab === TABS.METRC_EMPLOYEE_KEYS ? (
          <React.Fragment>
            <MetrcEmployees
              data={data}
              editMode={editMode}
              shops={shops}
              shop={shop}
              facilitiesOptions={facilitiesOptions}
              onChangeFacility={this.onChangeFacility}
              checkApiKey={this.checkApiKey}
              metrcEmployeeKeys={metrcEmployeeKeys}
              onUpdateEmployeeKey={this.props.onUpdateEmployeeKey}
              searchTerm={this.props.searchTerm}
              onSearchEmployeeKey={this.props.onSearchEmployeeKey}
              onChangeTerm={this.props.onChangeTerm}
              onDelete={this.openDeleteModal}
            />
            <AddMetrcEmployeeModal
              ref={this.addMetrcEmployeeModal}
              employees={employees}
              onEmployeeSearch={this.props.onEmployeeSearch}
              onSaveEmployeeKey={this.onSaveEmployeeKey}
            />
            <ModalDialog
              ref={(c) => (this.deleteModal = c)}
              onConfirm={this.onDeleteEmployeeKey}
              confirmText="delete"
            >
              Are you sure you want to delete '
              {(selectedEmployeeKey && selectedEmployeeKey.employeeName) || ''}' key?
            </ModalDialog>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Compliance/Compliance.js